var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c(
      "div",
      [
        _c(
          "VueHtml2pdf",
          {
            ref: "html2Pdf",
            attrs: {
              "show-layout": false,
              "float-layout": true,
              "enable-download": true,
              "preview-modal": true,
              "paginate-elements-by-height": 1400,
              filename: _vm.getFileName(),
              "pdf-quality": 2,
              "manual-pagination": false,
              "pdf-format": "a4",
              "pdf-orientation": "landscape",
              "pdf-content-width": "1100px"
            }
          },
          [
            _c(
              "section",
              { attrs: { slot: "pdf-content" }, slot: "pdf-content" },
              [
                _c("div", { staticClass: "mb15 p10 bg-cl-white" }, [
                  _c("div", { staticClass: "row mb15" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c("h4", { staticClass: "m0 mb5 mt5" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Zgłoszenie serwisowe ")) +
                            " " +
                            _vm._s(
                              _vm.currentComplaint.rma_number
                                ? _vm.currentComplaint.rma_number
                                : _vm.currentComplaint.id
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-2 col-lg-1" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6" },
                        [
                          _c("VueBarcode", {
                            attrs: {
                              value: _vm.currentComplaint.rma_number
                                ? _vm.currentComplaint.rma_number
                                : _vm.currentComplaint.id
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb15" }, [
                    _c("div", { staticClass: "col-xs-6 col-md-6" }, [
                      _c("h4", { staticClass: "m0 mb5 mt5" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Klient ")) +
                            " " +
                            _vm._s(_vm.currentComplaint.name) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6 h4" }, [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.currentComplaint.street) +
                            " " +
                            _vm._s(_vm.currentComplaint.house)
                        ),
                        _vm.currentComplaint.flat
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Flat")) +
                                  " " +
                                  _vm._s(_vm.currentComplaint.flat)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(
                          ", " +
                            _vm._s(_vm.currentComplaint.postcode) +
                            " " +
                            _vm._s(_vm.currentComplaint.city) +
                            "\n            "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb5" }, [
                    _c("div", { staticClass: "col-xs-6 h5" }, [
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Create date")) +
                            ":\n              " +
                            _vm._s(
                              _vm._f("date")(
                                _vm.currentComplaint.created,
                                "LLL",
                                _vm.storeView
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6 h5" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("Created by")) +
                            ": " +
                            _vm._s(_vm.currentComplaint.name)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb5" }, [
                    _c("div", { staticClass: "col-xs-6 h5" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("RMA ")) +
                            ": " +
                            _vm._s(_vm.currentComplaint.rma_type)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6 h5" }, [
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Status")) +
                            ": " +
                            _vm._s(
                              _vm._f("capitalize")(_vm.currentComplaint.status)
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb5" }, [
                    _c("div", { staticClass: "col-xs-12 h5" }, [
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Description")) +
                            ": " +
                            _vm._s(_vm.currentComplaint.description) +
                            "\n            "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb15" }, [
                    _vm.currentComplaint.rma_type === "service"
                      ? _c("div")
                      : _c("div", { staticClass: "col-xs-12 h5" }, [
                          _c("h4", [_vm._v(_vm._s(_vm.$t("Complaint items")))]),
                          _vm._v(" "),
                          _c("table", { staticClass: "brdr-cl-bg-secondary" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticClass: "sans-serif lh20" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("BP model")) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "sans-serif lh20" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.currentComplaint.rma_type ===
                                          "RMA_Zwrot" ||
                                          _vm.currentComplaint.rma_type ===
                                            "Zwrot"
                                          ? _vm.$t("Qty")
                                          : _vm.$t("Printer")
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "sans-serif lh20" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.currentComplaint.rma_type ===
                                          "RMA_Zwrot" ||
                                          _vm.currentComplaint.rma_type ===
                                            "Zwrot"
                                          ? _vm.$t("Invoice")
                                          : _vm.$t("Reason")
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.currentComplaint.items, function(
                                item
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: item.sku,
                                    staticClass: "brdr-cl-bg-secondary"
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "fs-medium lh15",
                                        attrs: { "data-th": _vm.$t("SKU") }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.part_number) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "fs-medium lh15",
                                        attrs: { "data-th": _vm.$t("Qty") }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.currentComplaint.rma_type ===
                                                "RMA_Zwrot" ||
                                                _vm.currentComplaint
                                                  .rma_type === "Zwrot"
                                                ? item.quantity
                                                : item.device
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "fs-medium lh15",
                                        attrs: { "data-th": _vm.$t("Reason") }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.currentComplaint.rma_type ===
                                                "RMA_Zwrot" ||
                                                _vm.currentComplaint
                                                  .rma_type === "Zwrot"
                                                ? item.invoice
                                                : item.reason
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c(
                                "tr",
                                { staticClass: "brdr-cl-bg-secondary" },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "align-right",
                                      attrs: { colspan: "6" }
                                    },
                                    [
                                      _c("cms-block-chunk", {
                                        attrs: {
                                          identifier: "c_COMPLAINT_PRINTE_PDF",
                                          "default-value": "<p/>"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                  ])
                ])
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }